import type React from 'react';
import { AppShell } from './components/AppShell';

type LayoutViewProps = {
    children: React.ReactNode;
    showBack: boolean;
    shouldWrapWithLayout: boolean;
};

export const LayoutView: React.FC<LayoutViewProps> = ({
    children,
    showBack,
    shouldWrapWithLayout,
}) => {
    if (!shouldWrapWithLayout) {
        return children;
    }

    return (
        <div
            className="min-h-screen"
            data-testid="layout-container"
            id="layout-container"
        >
            <AppShell showBack={showBack}>{children}</AppShell>
        </div>
    );
};
